import React, { forwardRef } from "react";
import { Input as TextInput } from "@clarkinc/zest-design-system/ui";
import { ProductListingView } from ".";

const ignoreNonNumericInput = (event: React.KeyboardEvent) => {
  const regex = RegExp("([^0-9]+)$");

  // Check key length to allow modifier and arrow keys through - ex. "ArrowDown"
  if (event.key.length === 1 && regex.test(event.key)) {
    event.preventDefault();
  }
};

interface Props {
  isOutlet: boolean;
  itemIsInCart: boolean;
  productListingView?: ProductListingView;
  handleAddToCart: (event: React.SyntheticEvent) => void;
  handleQuantityChange: (value: string) => void;
  quantity: string;
  previouslyPurchased?: boolean;
  opensModal?: boolean;
  itemNumber?: string;
}

const AddToCartButton = forwardRef<HTMLInputElement, Props>(
  (
    {
      isOutlet,
      itemIsInCart,
      handleAddToCart,
      handleQuantityChange,
      quantity,
      productListingView,
      previouslyPurchased = false,
      opensModal = false,
      itemNumber,
    },
    ref,
  ) => {
    const getGtmId = () => {
      if (opensModal) {
        return "";
      }
      if (previouslyPurchased) {
        return "BuyItAgainATC";
      }
      return "AddToCartATC";
    };

    if (isOutlet) {
      if (itemIsInCart) {
        return (
          <span className="btn btn-ui btn-block btn-medium disabled py-2 text-sm">
            Already in your cart
          </span>
        );
      }
      return (
        <input
          type="submit"
          className="btn btn-cart btn-small rounded"
          name="addToCartButton"
          value="Add to Cart"
          onClick={handleAddToCart}
          data-testid="itemAddCart"
          data-action="addToCart"
        />
      );
    }

    if (productListingView === "topProductsCarousel") {
      return (
        <>
          <TextInput
            ref={ref}
            id="itemAddCartQty"
            data-testid="itemAddCartQty"
            label="quantity"
            hideLabel
            inputSize="medium"
            theme="wss"
            inputMode="numeric"
            aria-describedby={`error-message-${itemNumber}`}
            min={1}
            value={quantity}
            onKeyDown={ignoreNonNumericInput}
            onValueChange={handleQuantityChange}
            className="h-auto absolute float-left w-8 px-0 py-2 -ml-[30px] mb-0 rounded rounded-r-none border-r-0 text-center leading-4"
          />
          <input
            type="submit"
            name="addToCartButton"
            className="rounded-[0_4px_4px_0] border-solid border-t border-r border-b border-l cursor-pointer inline-block justify-center float-right h-auto text-sm font-semibold leading-4 min-w-full p-2 relative text-white bg-red-500 hover:bg-red-800 border-black-10 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-red-800 btn"
            value="Add to Cart"
            onClick={handleAddToCart}
            data-testid="itemAddCart"
            data-action="addToCart"
          />
        </>
      );
    }

    return (
      <>
        <input
          ref={ref}
          className="add_qty quantity block text-base xs:text-sm"
          min="1"
          name="qty"
          aria-label="quantity"
          type="number"
          onKeyDown={ignoreNonNumericInput}
          onChange={({ target: { value } }) => handleQuantityChange(value)}
          value={quantity}
          data-testid="itemAddCartQty"
        />
        <input
          type="submit"
          className="btn btn-cart btn-small rounded-[0_4px_4px_0]"
          name="addToCartButton"
          value="Add to Cart"
          onClick={handleAddToCart}
          data-testid="itemAddCart"
          data-action="addToCart"
          gtm-id={getGtmId()}
        />
      </>
    );
  },
);

export default AddToCartButton;
